<template>
  <div class="main">

    <van-loading v-if="isLoading" />
    <div class="home-top">
      <div class="home-top-bg">
        <div class="title-bg-color">
          <div class="home-top-all">
            <div class="home-top-title">
              <div class="home-top-title-color"></div>
              <div class="home-top-title-text">设备总览</div>
            </div>
            <van-grid :column-num="2" border class="home-top-content-list">
              <van-grid-item  class="home-top-content-list-item">
                <ul class="detail-list">
                    <img src="@/assets/images/home/device.png" class="device-img"/>
                    <li class="device-text">接入设备 {{equipment.access}} </li>
                </ul>
              </van-grid-item>
              <van-grid-item  class="home-top-content-list-item">
                <ul class="detail-list">
                  <img src="@/assets/images/home/online_device.png" class="device-img"/>
                  <li class="device-text">在线设备 {{equipment.online}} </li>
                </ul>
              </van-grid-item>
            </van-grid>
          </div>
        </div>
      </div>
    </div>

    <!-- 告警统计 -->
    <div class="hot_spot">
      <div class="home-top-title">
        <div class="home-top-title-color"></div>
        <div class="home-top-title-text">告警统计</div>
      </div>

      <div style="padding: 10px">
        <Swiper class="box-swiper" :options="options" ref="mySwiper">
          <SwiperSlide class="box-swiper-slide" v-for="(item,index) in warnInfo" :key="index">
            <div class="warp-item" v-for="(c_item,c_index) in item.list" :key="index+'-'+c_index">
              <div :style="`background-image: url(` + c_item.h5AlgIcon +   `)`" class="warp-item-x">
                <div class="warp-x" >
                  <div class="warp-title">{{c_item.algName}}</div>
                  <div class="warp-t">{{c_item.count}}</div>
                </div>
              </div>


            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <!-- 告警分布 -->
    <div class="hot_distribution">
      <div class="home-top-title">
        <div class="home-top-title-color"></div>
        <div class="home-top-title-text">告警分布</div>
      </div>
      <dv-scroll-ranking-board :config="config" style="height: 300px"/>
    </div>

    <!-- 各单位告警统计 -->
    <div class="hot_distribution">
      <div class="home-top-title">
        <div class="home-top-title-color"></div>
        <div class="home-top-title-text">各单位告警统计</div>
      </div>
      <more-line-echarts  ref="moreLineEcharts" />
    </div>

  </div>
</template>

<script>
import { getEquipmentOverview,getAlarmStatistics,getUnitAlarmStatistics } from '@/api'
import LineEcharts  from '../Echarts/lineEcharts.vue'
import MoreLineEcharts  from '../Echarts/moreLineEcharts.vue'
export default {
  components: {
    LineEcharts,
    MoreLineEcharts
  },
  data() {
    return {
      //设备总览
      equipment: {
        access: 0, // 接入设备
        online: 0, // 在线设备
      },
      alert_show: false, // 弹窗显示与隐藏
      isLoading: false,
      instantLinkList: this.$globalVariable.instantLinkList,
      hotSpotList: this.$globalVariable.fieldList,
      isAdmin: false,
      warnInfo: [],
      options: {
        //自动轮播图
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        //无缝衔接
        loop: true,
        //分页器配置项
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 点击分页器小球进行轮播图切换
        },
      },
      config:{
        data: [],
        rowNum:3
      },
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    window.addEventListener('popstate', () => {
      this.goBack();
    })
  },
  async created() {
    this.getEquipmentOverview()
    this.getAlarmStatistics()
    this.getUnitAlarmStatistics()
  },
  methods: {
    goBack() {
      this.$router.push({ path: 'home' })
    },
    getUnitAlarmStatistics(){
      const _this = this
      getUnitAlarmStatistics({
        roleCode:localStorage.getItem('roleCode')
      }).then(res=>{
        if(res.data.state === 200){
          this.$nextTick(() => {
            _this.$refs.moreLineEcharts.init(res.data.data)
          })
        }
      })
    },
    getEquipmentOverview(){
      getEquipmentOverview().then(res=>{
        if(res.data.state === 200){
          this.equipment = res.data.data
        }
      })
    },
    getAlarmStatistics(){
      const dataList = []
      getAlarmStatistics({dateType:'day',roleCode:localStorage.getItem('roleCode')}).then(res=>{
        if(res.data.state === 200){
          const arr = []
          const obj = { list: [] }
          res.data.data.forEach((item, index) => {
            const data = {
              value:item.count,
              name:item.algName,
              icon:item.h5AlgIcon
            }
            dataList.push(data)
            this.config = {
              data: dataList,
              rowNum:3
            }
            obj.list.push(item)
            if ((index + 1) % 4 === 0) {
              arr.push(JSON.parse(JSON.stringify(obj)))
              obj.list = []
            }
            if (index + 1 === res.data.data.length) {
              arr.push(JSON.parse(JSON.stringify(obj)))
            }
          })
          this.warnInfo = arr
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.home-top-bg{
  height: 220px;
  background-image: url("@/assets/images/home/home_bg.png");
  background-size: 100% 100%;
  position: relative;
  background-position: center;
  overflow: hidden;
}
.title-bg-color{
  width: 100%;
  height: 100%;
  background: linear-gradient(231deg, #FFE0D8 0%, rgba(255, 187, 0, 0) 56%);
  border-radius: 0px 0px 0px 0px;
}
.home-top-all{
  background: #ffffff;
  border-radius: 8px;
  width: 87%;
  bottom: -10px;
  padding: 10px 10px;
  transform: translateX(4%);
  position: absolute;
}
.detail-list{
  width: 100%;
  height: 45px;
}
.home-top-title{
  display: flex;
}
.home-top-title-color{
  width: 2px;
  height: 16px;
  background: #3C77FF;
}
.home-top-title-text{
  width: 120px;
  height: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 6px;
}
.home-top-content-list {
  flex-wrap: nowrap;
  display: flex;
  justify-content: space-between;
}
.home-top-content-list-item{
  width: 47%;
}
/deep/.van-grid-item__content--center{
  align-items: normal;
}
.device-img{
  width: 90%;
  position: absolute;
}
.device-text{
  text-align: end;
  position: relative; /* 确保内容位于图片上方 */
  z-index: 200; /* 可选，但通常默认就是1或更高，所以这里主要是明确一下 */
  font-size: 16px;
  line-height: 50px;
  padding-top: 3px;
  padding-right: 14px;
}
.alarm-device-text{
  position: relative; /* 确保内容位于图片上方 */
  z-index: 100;
  font-size: 16px;
  margin-left: 25%;
  width: 75%;
  text-align: center;
  padding-top: 5px;
}
.alarm-device-num{
  position: relative; /* 确保内容位于图片上方 */
  z-index: 100;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #FF7547;
  line-height: 19px;
  margin-left: 25%;
  width: 75%;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.hot_spot{

  padding: 10px 20px;
}
.hot_distribution{
  width: 87%;
  padding: 10px 20px;
}
.alert-msg {
  font-size: 16px;
  margin: 20px 30px;
  text-align: center;
  line-height: 25px;
}
.box-swiper{
  height: 140px;
  width: 100%;
  .box-swiper-slide{
    width: 100%;
    height: 100%;
    display: grid;
    justify-content:space-between;
    align-content: space-between;
    grid-template-columns: repeat(2, 48%);
    grid-template-rows: repeat(2, 48%);
    .warp-item{
      margin: 3px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .warp-item-x{
        width: 100%;
        height: 95%;
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-end;
        .warp-x{
          width: 70%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{
            height: 20px;
            width: 20px;
          }
          .warp-title{
            margin-left: 5px;
            width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 13px;
            color: #586078;
            margin-bottom: 5px;
          }
        }
      }

      .warp-t{
        display: flex;
        font-weight: 400;
        font-size: 16px;
        color: #FF7547;
      }

      .img{
        width: 60px;
        img{
          width: 100%;
        }
        margin-right: 10px;
        .suan-name{
          width: 10%;
          position: absolute;
        }
      }
      .suan-bg{
        width: 90px;
        height: 50px;
        background-position-y: 7px;
        display: flex;
        font-family: "微软雅黑 Light";
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        color: white;
        font-size: 16px;
        .wrap-text{
          font-size: 20px;
        }
      }
    }
  }
}
::v-deep.dv-scroll-ranking-board .ranking-info {
  position: relative;
  top: -8px;
  color: #586078;
  font-size: 14px;
  .rank{
    display: none;
  }
}

::v-deep.dv-scroll-ranking-board .ranking-column{
  .inside-column{
    border-radius: 4px;
    background: linear-gradient( 90deg, #A4E4FF 0%, #5E8DFA 100%);
    height: 10px;
  }
  //border: none;
}
</style>
